import { render, staticRenderFns } from "./AddFeedback.vue?vue&type=template&id=df3b97b4&"
import script from "./AddFeedback.vue?vue&type=script&lang=js&"
export * from "./AddFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AddFeedback.vue?vue&type=style&index=0&id=df3b97b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports